import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { toast } from 'sonner';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const LOGO_URL = "/logo.svg";

export default function AdminLogin() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    if (!email || !password) {
      toast.error('Please fill in all fields.');
      return;
    }
    setLoading(true);
    try {
      const { data } = await axios.post(`${API}/auth/login`, { email, password });
      localStorage.setItem('admin_token', data.token);
      localStorage.setItem('admin_name', data.name);
      toast.success('Welcome back!');
      navigate('/admin/dashboard');
    } catch (err) {
      const detail = err.response?.data?.detail;
      toast.error(typeof detail === 'string' ? detail : 'Login failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0A0A0A] flex items-center justify-center px-6">
      <div className="w-full max-w-sm">
        <div className="flex flex-col items-center mb-10">
          <img src={LOGO_URL} alt="CSF Logo" className="h-16 w-16 object-contain mb-4" />
          <h1 className="font-display font-bold text-xl text-white tracking-tight">Admin Login</h1>
          <p className="text-sm text-[#A3A3A3] mt-1">Contractors of South Florida</p>
        </div>

        <form onSubmit={handleLogin} data-testid="admin-login-form" className="space-y-5">
          <div>
            <Label htmlFor="admin-email" className="text-white text-sm mb-2 block">Email</Label>
            <Input
              id="admin-email"
              type="email"
              data-testid="admin-login-email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="admin@contractorsfl.com"
              className="bg-[#1A1A1A] border-white/10 text-white placeholder:text-[#666] focus-visible:ring-[#E31937] h-12 rounded-none"
            />
          </div>
          <div>
            <Label htmlFor="admin-password" className="text-white text-sm mb-2 block">Password</Label>
            <Input
              id="admin-password"
              type="password"
              data-testid="admin-login-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter password"
              className="bg-[#1A1A1A] border-white/10 text-white placeholder:text-[#666] focus-visible:ring-[#E31937] h-12 rounded-none"
            />
          </div>
          <button
            type="submit"
            data-testid="admin-login-submit"
            disabled={loading}
            className="w-full bg-[#E31937] text-white font-bold uppercase tracking-wider px-8 py-4 hover:bg-[#FF2445] transition-colors disabled:opacity-50 text-sm"
          >
            {loading ? 'Signing in...' : 'Sign In'}
          </button>
        </form>

        <a href="/" data-testid="back-to-site" className="block text-center text-xs text-[#A3A3A3] hover:text-white transition-colors mt-8 uppercase tracking-wider">
          Back to Website
        </a>
      </div>
    </div>
  );
}
